import { IIconProps } from '@fluentui/react';
import { IPFontIcon } from 'baseComponents';
import {
  listTypeCustomListIcon,
  listTypeDocLibraryIcon,
  listTypeSitePageLibraryIcon,
  listTypeWebURLIcon,
} from 'globalStyles';
import { DocumentProviderType } from 'models/documentProvider';
import {
  PublishingStateResourceLink,
  PublishingStateSharePoint,
  ResourceLinkPublishingState,
} from 'models/resourceLink';
import ResourceList, { ResourceListType } from 'models/resourceList';

export const getListIcon = (item: ResourceList): IIconProps | undefined => {
  // a category on another provider is shown by provider rather than by item kind: which system
  // holds the content is what a user needs to recognize in a list of categories
  const providerIcon = getProviderIcon(item.providerType);
  if (providerIcon) return providerIcon;

  if (item.listType === ResourceListType.CustomList) return listTypeCustomListIcon;
  if (item.listType === ResourceListType.DocumentLibrary) return listTypeDocLibraryIcon;
  if (item.listType === ResourceListType.WebURL) return listTypeWebURLIcon;
  if (item.listType === ResourceListType.SitePageLibrary) return listTypeSitePageLibraryIcon;

  return undefined;
};

/**
 * Fluent has no brand icons for these providers, so each gets a neutral icon that says what
 * kind of place it is. Undefined for SharePoint and virtual categories, which keep the
 * item-kind icons above.
 */
export const getProviderIcon = (providerType: DocumentProviderType): IIconProps | undefined => {
  switch (providerType) {
    case DocumentProviderType.GoogleDrive:
      return { iconName: 'CloudUpload' };
    case DocumentProviderType.Nextcloud:
      return { iconName: 'Cloud' };
    case DocumentProviderType.Notion:
      return { iconName: 'PageList' };
    case DocumentProviderType.MicrosoftLoop:
      return { iconName: 'Room' };
    default:
      return undefined;
  }
};

export const getPublicationStateIcon = (
  state: ResourceLinkPublishingState | undefined,
  color?: string,
): JSX.Element | null => {
  switch (state) {
    case PublishingStateSharePoint.Published:
      return <IPFontIcon style={{ fontSize: 16, color: color || 'green', cursor: 'pointer' }} iconName={'Checkmark'} />;
    case PublishingStateSharePoint.Draft:
      return (
        <IPFontIcon style={{ fontSize: 16, color: color || 'orange', cursor: 'pointer' }} iconName={'WebPublish'} />
      );
    case PublishingStateResourceLink.ToBePublished:
      return (
        <IPFontIcon style={{ fontSize: 16, color: color || 'orange', cursor: 'pointer' }} iconName={'Checkmark'} />
      );
    default:
      return null;
  }
};
